export type TLoginData = {
  username: string;
  password: string;
  isRememberUsername: boolean;
};

export enum ONEPASS_STATUS {
  NON,
  success,
  ERROR,
}
